// ─── Feuille : CHOISIR UN COMPTE (nom + adresse, avec recherche) ──
// Sert à donner un rôle (administrateur / commerce) sans retaper l'adresse :
// on pioche dans les comptes existants. Les comptes DÉJÀ dans la liste sont
// masqués (`exclus`).
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, EmptyState, stylesForm, useUI, useT } from '@mop/core';
import { ecouterComptes } from './services/admin';
import LigneCompte from './LigneCompte';

export default function FeuilleChoixCompte({ visible, titre, exclus = [], onChoisir, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [comptes, setComptes] = useState([]);
  const [q, setQ] = useState('');

  useEffect(() => {
    if (!visible) return undefined;
    setQ('');
    return ecouterComptes(setComptes, () => {});
  }, [visible]);

  const bas = (x) => String(x || '').toLowerCase();
  const listes = useMemo(() => {
    const rq = q.trim().toLowerCase();
    const dejaLa = exclus.map(bas);
    return comptes
      .filter(c => c.email && !dejaLa.includes(bas(c.email)))
      .filter(c => !rq || `${c.email} ${c.prenom || ''}`.toLowerCase().includes(rq));
  }, [comptes, q, exclus]);

  return (
    <Feuille visible={visible} titre={titre || t('admin.choisirCompte')} emoji="👤" hauteur={0.7} onFermer={onFermer}>
      <View style={s.barre}>
        <Text style={s.ic}>🔍</Text>
        <TextInput style={s.rech} value={q} onChangeText={setQ} autoCapitalize="none" autoCorrect={false}
          placeholder={t('admin.rechercheCompte')} placeholderTextColor={UI.faint} />
        {!!q && <TouchableOpacity onPress={() => setQ('')}><Text style={s.ic}>✕</Text></TouchableOpacity>}
      </View>

      {listes.length === 0 ? (
        <EmptyState icon="👤" texte={t('admin.aucunCompte')} aide={t('admin.aucunCompteAide')} />
      ) : listes.map(c => (
        <TouchableOpacity key={c.uid} style={s.ligne} activeOpacity={0.7}
          onPress={() => { onChoisir?.(c); onFermer?.(); }}>
          {/* Ces lignes VIENNENT de la liste des comptes : elles sont inscrites
              par construction, même celles dont le prénom est vide. */}
          <LigneCompte email={c.email} nom={c.prenom} inscrit />
          <Text style={s.chev}>›</Text>
        </TouchableOpacity>
      ))}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  barre: { flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: UI.champ,
           borderRadius: 11, paddingHorizontal: 12, borderWidth: 0.5, borderColor: UI.champBord, marginBottom: 6 },
  ic: { fontSize: 15, color: UI.muted },
  rech: { flex: 1, fontSize: 14.5, color: UI.ink, paddingVertical: 9 },
  ligne: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 10,
           borderTopWidth: 0.5, borderTopColor: UI.border },
  chev: { fontSize: 18, color: UI.faint },
});
